import { FC } from 'react'

export const Twitter: FC = () => (
  <svg
    width="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3319 14.7749L22.5437 8H21.3087L16.7833 13.8826L13.1688 8H9L14.4657 16.8955L9 24H10.2351L15.0141 17.7878L18.8312 24H23L17.3316 14.7749H17.3319ZM15.6403 16.9738L15.0865 16.0881L10.6801 9.03974H12.5772L16.1331 14.728L16.6869 15.6137L21.3093 23.0075H19.4122L15.6403 16.9742V16.9738Z"
      fill="currentColor"
    />
  </svg>
)
